namespace Solovis.Reports.Parts.Tables.DataTableHelper {


    export function getResourcePropertyValueColumns(options) {
        var tableControl = options.tableControl;
        var propertiesParameter = options.propertiesParameter;
        var asOfDateParameter = options.asOfDateParameter ? options.asOfDateParameter : null;
        var propValuesDataSourceName = options.resourcePropertyValuesDataSourceName;
        var canEdit = options.canEdit ? true : false;
        var columnIdPrefix = options.columnIdPrefix ? options.columnIdPrefix : "";
        var columnSuperHeaders = options.columnSuperHeaders ? options.columnSuperHeaders : null;

        var resourceIdGetter;
        if (options.resourceIdGetter) {
            // options.resourceIdGetter should be a function with signature function (row) that returns resourceId.
            resourceIdGetter = options.resourceIdGetter;
        }
        else {
            resourceIdGetter = function (row) {
                return row.resourceId;
            };
        }

        var getPropValueInstance = function (resourceId, propDefId) {
            var propValueInstance = null;

            // propValues should be the standard data set for resource property values.
            var propValues = tableControl.dataSets[propValuesDataSourceName];
            if (propValues) {
                var propValueMap = propValues.resourceIdToPropValueMap[resourceId];
                if (propValueMap) {
                    propValueInstance = propValueMap[propDefId];
                }
            }

            return propValueInstance;
        };

        var updatePropValueInstance = function (resourceId, propDefId, newPropValueInstance) {
            // This will update the data set after we modify a property in place.

            var propValues = tableControl.dataSets[propValuesDataSourceName];

            var propValueMap = propValues.resourceIdToPropValueMap[resourceId];
            if (!propValueMap) {
                propValueMap = {};
                propValues.resourceIdToPropValueMap[resourceId] = propValueMap;
            }

            propValueMap[propDefId] = newPropValueInstance;
        };

        var getMainModelEnv = function () {
            var propValues = tableControl.dataSets[propValuesDataSourceName];
            if (!propValues) {
                throw "Data source not found on table control: " + propValuesDataSourceName;
            }

            return propValues.modelEnvironment;
        };

        var getExportDataType = function (propDefId) {
            var modelEnv = getMainModelEnv();
            var propDef = modelEnv.propertyDefinitions.tryGetById(propDefId);
            if (propDef) {
                return InvData.Util.GetDataTypeByPropertyType(propDef.propertyTypeId);
            }

            return null;
        };

        var getExportGetter = function (propDefId) {
            var modelEnv = getMainModelEnv();
            var propDef = modelEnv.propertyDefinitions.tryGetById(propDefId);
            if (propDef) {
                var propTypeIds = InvData.PropertyTypeIds;

                if (propDef.propertyTypeId == propTypeIds.Boolean) {
                    return function (row) {
                        var resourceId = resourceIdGetter(row);
                        var propValueInstance = getPropValueInstance(resourceId, propDefId);
                        if (propValueInstance) {
                            return propValueInstance.value.b;
                        }

                        return null;
                    }
                }
                else if (propDef.propertyTypeId == propTypeIds.Decimal || propDef.propertyTypeId == propTypeIds.Currency) {
                    return function (row) {
                        var resourceId = resourceIdGetter(row);
                        var propValueInstance = getPropValueInstance(resourceId, propDefId);
                        if (propValueInstance) {
                            return propValueInstance.value.d;
                        }

                        return null;
                    }
                }
                else if (propDef.propertyTypeId == propTypeIds.Date) {
                    return function (row) {
                        var resourceId = resourceIdGetter(row);
                        var propValueInstance = getPropValueInstance(resourceId, propDefId);
                        if (propValueInstance) {
                            return propValueInstance.value.dt;
                        }

                        return null;
                    }
                }
                else if (propDef.propertyTypeId == propTypeIds.String
                    || propDef.propertyTypeId == propTypeIds.LongText
                    || propDef.propertyTypeId == propTypeIds.Html
                    || propDef.propertyTypeId == propTypeIds.Url
                ) {
                    return function (row) {
                        var resourceId = resourceIdGetter(row);
                        var propValueInstance = getPropValueInstance(resourceId, propDefId);
                        if (propValueInstance) {
                            return propValueInstance.value.s;
                        }

                        return null;
                    }
                }
                else if (propDef.propertyTypeId == propTypeIds.TagRef) {
                    return function (row) {
                        var resourceId = resourceIdGetter(row);
                        var propValueInstance = getPropValueInstance(resourceId, propDefId);
                        if (propValueInstance) {
                            return propValueInstance.value.t;
                        }

                        return null;
                    }
                }
                else if (propDef.propertyTypeId == propTypeIds.EntityRef) {
                    return function (row) {
                        var resourceId = resourceIdGetter(row);
                        var propValueInstance = getPropValueInstance(resourceId, propDefId);
                        if (propValueInstance) {
                            return propValueInstance.value.e;
                        }

                        return null;
                    };
                }
                else if (propDef.propertyTypeId == propTypeIds.InvestmentRef
                    || propDef.propertyTypeId == propTypeIds.ContactRef
                    || propDef.propertyTypeId == propTypeIds.NoteRef
                    || propDef.propertyTypeId == propTypeIds.TransactionRef
                ) {
                    return function (row) {
                        var resourceId = resourceIdGetter(row);
                        var propValueInstance = getPropValueInstance(resourceId, propDefId);
                        if (propValueInstance) {
                            return propValueInstance.value.r;
                        }

                        return null;
                    };
                }
                else if (propDef.propertyTypeId == propTypeIds.Integer
                    || propDef.propertyTypeId == propTypeIds.UserRef
                ) {
                    return function (row) {
                        var resourceId = resourceIdGetter(row);
                        var propValueInstance = getPropValueInstance(resourceId, propDefId);
                        if (propValueInstance) {
                            return propValueInstance.value.i;
                        }

                        return null;
                    };
                }
            }

            return null;
        };

        var columns = [];

        if (tableControl.parameters[propertiesParameter]) {
            $(tableControl.parameters[propertiesParameter]).each(function (i, prop: any) {
                var colExportGetter = getExportGetter(prop.id);
                var columnId = columnIdPrefix + "prop" + prop.code;

                var column: any = {
                    id: columnId,
                    label: prop.label,
                    field: function (row) {
                        if (row._groupId === columnId) {
                            return row._groupRep;
                        }

                        if (colExportGetter) {
                            var value = colExportGetter(row);
                            if (!prop.allowMultiple) {
                                if (value && value.length == 1) {
                                    return value[0];
                                }
                            }

                            return value;
                        }
                    },

                    superHeaders: columnSuperHeaders,

                    exportDataType: getExportDataType(prop.id),
                    exportGetter: colExportGetter,

                    applyStandardGrouping: true,

                    htmlFormatter: function (cellValue, cellContext) {
                        if (cellContext.aggregate || cellContext.group) {
                            return cellContext.defaultFormatter(cellValue, cellContext);
                        }

                        var row = cellContext.row;
                        var resourceId = resourceIdGetter(row);
                        var propDefId = prop.id;
                        var propTypeId = prop.propertyTypeId;

                        var cellDiv = $("<div>");

                        var editLink = null;
                        if (canEdit && Solovis.isNotNull(resourceId)) {
                            editLink = $('<a><span class="ui-icon ui-icon-pencil"></span>').css("float", "right").appendTo(cellDiv)
                                .addClass("no-print");
                        }

                        var propDiv = $("<div>").appendTo(cellDiv);

                        var propValueInstance = getPropValueInstance(resourceId, propDefId);
                        if (propValueInstance) {
                            var propHtml = Solovis.Reports.Formatter.formatResourcePropertyValueAsHtml({
                                property: propValueInstance.property,
                                resourcePropertyValue: propValueInstance,
                                printMode: tableControl.printMode
                            });

                            propDiv.html(propHtml as any);
                        }

                        if (editLink) {
                            editLink.click(function () {
                                var propValueInstance = getPropValueInstance(resourceId, propDefId);

                                var fromDayId = null;
                                if (propValueInstance && propValueInstance.value) {
                                    fromDayId = propValueInstance.value.from;
                                }

                                Solovis.Properties.PropertyEditor.editResourceProperty({
                                    resourceId: resourceId,
                                    propertyDefinitionId: propDefId,
                                    propertyTypeId: propTypeId,
                                    from: fromDayId,

                                    saveCallback: function () {
                                        var asOfDayId = null;
                                        if (asOfDateParameter) {
                                            asOfDayId = tableControl.parameters[asOfDateParameter];
                                        }

                                        Solovis.Reports.ReportDataLoader.loadDataSetAsync(
                                            '/Solovis/Metadata/ResourcePropertyValues',
                                            {
                                                resourceId: resourceId,
                                                propertyDefinitionIdList: [prop.id],
                                                asOfDayId: tableControl.parameters[asOfDateParameter],
                                                loadAllValuesThroughTime: false
                                            },
                                            function (response, success) {
                                                if (success) {
                                                    // We should have 1 property value.
                                                    var dataSet = response.result.dataSet;

                                                    // We should only have 1 property definition which is the one we requested.
                                                    var propDef = null;
                                                    var modelEnv = dataSet.modelEnvironment;
                                                    if (modelEnv.propertyDefinitions && modelEnv.propertyDefinitions.length > 0) {
                                                        propDef = modelEnv.propertyDefinitions[0];
                                                    }

                                                    var propValues = dataSet.propertyValues;
                                                    if (propValues && propValues.length > 0) {
                                                        var propValueInstance = propValues[0];

                                                        Solovis.Reports.StandardDataSources._updateResourcePropertyValue(propValueInstance, getMainModelEnv());

                                                        var propHtml = Solovis.Reports.Formatter.formatResourcePropertyValueAsHtml({
                                                            property: propDef,
                                                            resourcePropertyValue: propValueInstance,
                                                            printMode: tableControl.printMode
                                                        });

                                                        propDiv.html(propHtml as any);

                                                        updatePropValueInstance(resourceId, propDefId, propValueInstance);
                                                    }
                                                    else {
                                                        propDiv.html("");
                                                    }
                                                }
                                            });
                                    }
                                });
                            });
                        }

                        return cellDiv;
                    }
                };

                if (!prop.allowMultiple) {
                    column.dataType = column.exportDataType;
                }

                var modelEnv = getMainModelEnv();
                var propDef = modelEnv.propertyDefinitions.tryGetById(prop.id);

                if (propDef && propDef.propertyTypeId == InvData.PropertyTypeIds.TagRef) {
                    column.tagSetId = propDef.tagRefTagSetId;
                }

                columns.push(column);
            });
        }

        return columns;
    };

    export function getResourcePropertyValueSorts(options) {
        // NOTE: We no longer return custom property value sorts because we now specify the dataType on the column itself,
        //   which allows the default property sorts to kick in.
        return [];
    };

    export function getResourcePropertyValueGroups(options) {
        // NOTE: We no longer return custom property value groups because we now specify the applyStandardGrouping on the column itself,
        //   which allows the default groups to kick in.
        return [];
    };

}
